var hatchMixin = {
    data: function () {
        return {
            product: {
                hatch: 0
            }
        }
    },
    methods: {
        selectHatch: function (hatch) {
            const vm = this;
            vm.product.hatch = Number(hatch);
            vm.updateProductPrice();
        }
    },
}